import { render, staticRenderFns } from "./fb-messenger.vue?vue&type=template&id=132fb459&lang=pug&"
import script from "./fb-messenger.vue?vue&type=script&lang=js&"
export * from "./fb-messenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports